import React, { useEffect, useState } from "react"
import {
  HeroContainer,
  HeroContent,
  HeroTitle,
  GenereContainer,
  Year,
  GenereLink,
  Date,
  HeroOverview,
  Rating,
} from "./styles/hero"
import { Icon } from "../../components"
import Color from "../../constants/Color"
import { Container } from "../../containers"

export default function Hero({ children, path, ...rest }) {
  return (
    <HeroContainer {...rest} path={path}>
      <Container>{children}</Container>
    </HeroContainer>
  )
}

Hero.Content = function HeroContents({ children, ...rest }) {
  return <HeroContent {...rest}>{children}</HeroContent>
}
Hero.Title = function HeroTitles({ children, year, ...rest }) {
  return (
    <HeroTitle {...rest}>
      {children} <Year {...rest}>({year})</Year>
    </HeroTitle>
  )
}
Hero.Date = function HeroDate({ children, ...rest }) {
  return <Date {...rest}>{children}</Date>
}

Hero.Overview = function HeroOverviews({ children, ...rest }) {
  return <HeroOverview {...rest}>{children}</HeroOverview>
}
Hero.Year = function HeroYears({ children, ...rest }) {
  return <Year {...rest}>({children})</Year>
}

Hero.Rating = function HeroRating({ rate, ...rest }) {
  const [colorTheme, setColor] = useState("")
  const [bgColor, setBgColor] = useState()
  let number = parseInt(rate)
  useEffect(() => {
    if (rate && number < 4) {
      setColor(Color.bad)
      setBgColor(Color.badBg)
    } else if (number > 3.9 && number < 7) {
      setColor(Color.ok)
      setBgColor(Color.okBg)
    } else if (number > 6.9 && number < 8) {
      setColor(Color.great)
      setBgColor(Color.greatBg)
    } else if (number > 7.9) {
      setColor(Color.superb)
      setBgColor(Color.superbBg)
    } else {
      setColor(Color.white)
    }
    // eslint-disable-next-line
  }, [number])

  return (
    <Rating {...rest} bg={bgColor} color={colorTheme}>
      <Icon name="ph-star-fill" color={colorTheme} />
      <p>{parseFloat(rate).toFixed(1)}</p>
    </Rating>
  )
}
Hero.GenereContainer = function HeroGenereContainers({ children, ...rest }) {
  return <GenereContainer {...rest}>{children}</GenereContainer>
}

Hero.GenereLink = function HeroGenereLinks({ children, to, ...rest }) {
  return (
    <GenereLink {...rest} to={to}>
      {children}
    </GenereLink>
  )
}
